<template>
  <div :class="{ 'c-tabs-editing': isEditing }">
    <sc-text v-if="isEditing" tag="h5" :field="fields.name" />
    <sc-placeholder name="jss-tab-secondary-content" :rendering="rendering" />
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Tabs-Secondary-Tab',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>
<style lang="scss" scoped>
.c-tabs-editing {
  border: solid 1px $divider;
  padding: 2rem;
  margin-bottom: 5rem;
}
</style>
